import { PaginatedResponse } from '@gorila-shared-ui/components';
import { atom } from 'recoil';
import { Integration } from '../types/integrations';

export const loadingIntegrationsState = atom({
  key: 'app.client.integrations.loading',
  default: false,
});

export const integrationsState = atom<PaginatedResponse<Integration> | undefined>({
  key: 'app.client.integrations',
  default: undefined,
});

export const searchIntegrationState = atom<string | undefined>({
  key: 'app.client.integrations.search',
  default: undefined,
});

export const integrationsPageState = atom({
  key: 'app.client.integrations.page',
  default: 1,
});
